import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import getfile from "../../utils/getFile";
import { ItemHelper } from "../helpers/item-helper"; // ปรับ path ตามที่ใช้จริง
import { useLiffProfile } from "../../context/LiffProfileContext";

export default function BcCouponCard({
  value = {},
  mode = "horizontal",
  onClick,
}) {
  const { i18n } = useTranslation();
  const lang = i18n.language.toUpperCase();
  const { authToken, userId } = useLiffProfile();

  const isHorizontal = mode === "horizontal";

  const [thumbnail, setThumbnail] = useState(null);
  const [seniorLayout, setSeniorLayout] = useState(() => {
    // ปรับ logic นี้หากคุณใช้ context หรือ localStorage แทน Vuex
    return localStorage.getItem("seniorLayout") === "true";
  });

  useEffect(() => {
    if (value.thumbnail) {
      // Assuming you have a method to fetch the thumbnail
      fetchThumbnail(value.thumbnail).then((thumbnailUrl) =>
        setThumbnail(thumbnailUrl)
      );
    }
  }, [value.thumbnail]);

  const fetchThumbnail = async (thumbnail) => {
    // Your method to fetch the thumbnail image
    const thumbnailUrl = await getfile(thumbnail, authToken, userId);
    //console.log(thumbnailUrl);
    return thumbnailUrl;
  };
  const couponName = ItemHelper.getName(value, lang);
  const couponTag = ItemHelper.getTag(value, lang);

  return (
    <div
      className={`w-full h-full bg-white border border-overlay-12 rounded-2xl cursor-pointer ${
        isHorizontal
          ? "flex flex-row"
          : "grid grid-cols-1 auto-rows-max items-start"
      } ${
        seniorLayout
          ? isHorizontal
            ? "gap-2.5 p-2"
            : "gap-2.5 p-3"
          : "gap-3 sm:gap-1 p-2"
      }`}
      onClick={(e) => {
        e.preventDefault();
        onClick?.(value.id);
      }}
    >
      <div
        className={`relative flex justify-center items-center ${
          seniorLayout
            ? isHorizontal
              ? "basis-36 flex flex-col gap-1"
              : "w-full"
            : isHorizontal
            ? "w-[30%]"
            : "w-full"
        }`}
      >
        <div
          className={`relative rounded-xl overflow-hidden ${
            seniorLayout
              ? isHorizontal
                ? "basis-36"
                : "w-full h-auto"
              : isHorizontal
              ? "w-28 h-28"
              : "w-full h-auto"
          }`}
          style={!isHorizontal ? { aspectRatio: "1/1" } : {}}
        >
          {thumbnail && (
            <img
              src={thumbnail}
              alt={couponName}
              className="object-contain w-full h-full relative z-20"
              onError={(e) => e.currentTarget.classList.add("hidden")}
            />
          )}
          <div className="w-full h-full bg-overlay-5 absolute top-0 z-10" />
        </div>
      </div>

      <div
        className={`flex flex-col gap-y-1 mx-2 text-left ${
          seniorLayout ? "flex-grow basis-40" : "w-full"
        }`}
      >
        <div
          className={`font-semibold line-clamp-2 ${
            seniorLayout ? "text-lg" : "text-base"
          }`}
        >
          {couponName}
        </div>
        <div
          className={`font-normal break-words ${
            seniorLayout
              ? isHorizontal
                ? "text-base line-clamp-3"
                : "text-lg line-clamp-3"
              : "text-sm line-clamp-3"
          }`}
          dangerouslySetInnerHTML={{ __html: couponTag }}
        />
      </div>
    </div>
  );
}
